import React from 'react'
import PropTypes from 'prop-types'

const emotionHeading = (score) => {
	if(score >= 90) { return 'Your Ad Account Is Great' }
	if(score >= 80) { return 'Your Ad Account Is Good' }
	if(score >= 70) { return 'Your Ad Account Is Decent' }
	return 'Your Ad Account Could Use Some Work'
}

const emotionBody = (score) => {
	if(score >= 90) { return 'You are a master of Facebook Advertising! Let\'s go from great to flawless!' }
	if(score >= 80) { return 'You know what you are doing! Let\'s get your advertising to flawless!' }
	if(score >= 70) { return 'Great start! Let\'s see how we can bump up your score.' }
	return 'That\'s ok though. You have to start somewhere!'
}

export default function Score(props) {
	const { score } = props
	return (
		<div className="score-section">
			<div className="content-wrap">
				<div className="score-box">
					{/* <span className="score-text">Your</span> */}
					<div className="score-group-border">
						<div className="score-group">
							<span className="actual-score">{score}</span>
							<span>/100</span>
						</div>
					</div>
					{/* <span className="score-text">Score</span> */}
				</div>
				<div className="content-wrap account-name">
					<span className="company-name">{props.name}</span>
				</div>
				<div className="score-emotion">
					<h2>{emotionHeading(score)}</h2>
					<h4>{emotionBody(score)}</h4>
				</div>
			</div>
		</div>
	)
}

Score.propTypes = {
	score: PropTypes.number,
	name: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/containers/ReportLoader/components/Score.js